import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from 'context/AuthContext';
import { safeJSONParse } from 'utils/helpers/safeParsing';
import type { ServiceContextValue, ServiceProviderProps } from '../types';

const ServiceContext = createContext<ServiceContextValue | null>(null);

export const useService = (): ServiceContextValue => useContext(ServiceContext) as ServiceContextValue;

export const ServiceProvider = ({ children }: ServiceProviderProps) => {
    const { auth } = useAuth();
    const orderName = `voltox-${auth.user.ID}-service-order`;
    const descName = `voltox-${auth.user.ID}-service-desc`;

    const [showEditService, setShowEditService] = useState<number | false>(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [listResetNonce, setListResetNonce] = useState(0);
    const [listRefreshNonce, setListRefreshNonce] = useState(0);
    const [servicesOrder, setServicesOrder] = useState<string | false>(
        safeJSONParse(sessionStorage.getItem(orderName)) || '',
    );
    const [servicesDesc, setServicesDesc] = useState(
        safeJSONParse(sessionStorage.getItem(descName)) === true,
    );
    const [serviceCheck, setServiceCheck] = useState<number[]>([]);

    useEffect(() => {
        sessionStorage.setItem(orderName, JSON.stringify(servicesOrder));
    }, [servicesOrder, orderName]);

    useEffect(() => {
        sessionStorage.setItem(descName, JSON.stringify(servicesDesc));
    }, [servicesDesc, descName]);

    const triggerListReset = () => setListResetNonce((nonce) => nonce + 1);
    const triggerListRefresh = () => setListRefreshNonce((nonce) => nonce + 1);

    const values: ServiceContextValue = {
        showEditService,
        setShowEditService,
        showSpinner,
        setShowSpinner,
        servicesOrder,
        setServicesOrder,
        servicesDesc,
        setServicesDesc,
        serviceCheck,
        setServiceCheck,
        listResetNonce,
        triggerListReset,
        listRefreshNonce,
        triggerListRefresh,
    };

    return <ServiceContext.Provider value={values}>{children}</ServiceContext.Provider>;
};
